export const getRowId = ({ depth, id }) => {
  return `${depth}_${id}`
}
